import { LABEL_ENTITY_VALUE, LabelFormField } from '../../../../../Label'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function LabelsValueField({ label, name, placeholder }) {
  return (
    <LabelFormField
      entity={LABEL_ENTITY_VALUE.request}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      name={name}
      placeholder={placeholder}
    />
  )
}

export default LabelsValueField
